angular.module('app.transformResource', [])

/**
 * @ngdoc service
 * @name app.transformResource
 * @description
 * # transformResource
 * Handles request and reponse transformation attaching the new functions to
 * the default and global ones from $http
 * e.g.:
 * $http({
 *   url: '...',
 *   method: 'GET',
 *   transformResponse: transformResource.onResponse(SomeResponseHandlerFn)
 * });
 * $http({
 *   url: '...',
 *   method: 'GET',
 *   transformResponse: transformResource.onResponse([
 *           myResponseHandlerService.formatUrl,
 *           myResponseHandlerService.parseDate,
 *           myResponseHandlerService.camelCaseNameStr
 *       ])
 * });
 */
  .factory('app.transformResource', [
    '$http',
    function ($http) {
      'use strict';

      let defaults = $http.defaults;

      function getFnArray(fnArray) {
        return _.isArray(fnArray) ? fnArray : [fnArray];
      }

      function appendTransformFnToDefaults(fnList) {
        return defaults.transformResponse.concat(getFnArray(fnList));
      }

      function appendDefaultsToTransformFn(fnList) {
        return getFnArray(fnList).concat(defaults.transformRequest);
      }

      //noinspection JSValidateJSDoc
      return {
        /**
         * Adds a function or array function to the default response transformations
         * on $http
         * @type {Array.<function(data, headersGetter)>}
         */
        onResponse: appendTransformFnToDefaults,
        /**
         * Adds a function or array function to the default request transformations
         * on $http
         * @type {Array.<function(data, headersGetter)>}
         */
        onRequest: appendDefaultsToTransformFn
      };
    }]);


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/transformResource.js